export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              关于我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              了解快看影视的故事与使命
            </p>
          </div>

          <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
            <div className="flex flex-col lg:flex-row gap-8 items-start">
              <div className="flex-1">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  <strong className="text-foreground-950">快看影视</strong>成立于对电影的热爱之中。我们深知每一位影迷在寻找高清片源时的困扰——加载缓慢、画质模糊、广告弹窗不断。
                  因此，我们打造了这个专注于<strong className="text-foreground-950">高清免费电影在线观看</strong>的平台，让观影回归纯粹的享受。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  我们持续扩充<strong className="text-foreground-950">电影大全</strong>片库，确保<strong className="text-foreground-950">最新电影</strong>第一时间上线。
                  通过先进的内容分发与解码技术，我们实现了<strong className="text-foreground-950">流畅高清不卡顿免费看</strong>的承诺，让每一帧画面都清晰动人。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  未来，快看影视将继续优化观影体验，丰富影片资源，用技术与热情为每一位用户打造最好的<strong className="text-foreground-950">免费电影在线观看</strong>平台。
                </p>
              </div>
              <div className="flex-shrink-0 flex flex-col gap-4">
                <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-primary-50">
                  <i className="ri-user-heart-line text-xl text-primary-500"></i>
                  <div>
                    <div className="text-lg font-bold text-primary-600">500万+</div>
                    <div className="text-xs text-foreground-500">累计观影用户</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-accent-50">
                  <i className="ri-timer-flash-line text-xl text-accent-500"></i>
                  <div>
                    <div className="text-lg font-bold text-accent-600">3秒</div>
                    <div className="text-xs text-foreground-500">平均加载时间</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}